import { render, staticRenderFns } from "./PersonAttachmentsTab.vue?vue&type=template&id=21518ff4&"
import script from "./PersonAttachmentsTab.vue?vue&type=script&lang=js&"
export * from "./PersonAttachmentsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports